import { render, staticRenderFns } from "./itemcatg.vue?vue&type=template&id=f753fb9c&scoped=true"
import script from "./itemcatg.vue?vue&type=script&lang=js"
export * from "./itemcatg.vue?vue&type=script&lang=js"
import style0 from "./itemcatg.vue?vue&type=style&index=0&id=f753fb9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f753fb9c",
  null
  
)

export default component.exports